import React from "react";
import { Box, Grid } from "@mui/material";
import {
  AccessTimeOutlined,
  PersonOutline,
  UpdateOutlined,
  InfoOutlined,
  PublicOutlined,
  Code,
  Description,
  PinDropOutlined,
  LocationCity as LocationCityIcon,
} from "@mui/icons-material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useDistrictDetailContext } from "contexts/LocationContexts/DistrictDetailContext";
import { localizeDateTimeMed } from "utils/dateFormats";
import ReactHtmlParser from "html-react-parser";

const DistrictBasicDetails = () => {
  const { districtDetail, loadingDetail } = useDistrictDetailContext();

  const districtInfo = [
    {
      title: "District Name",
      icon: <LocationCityIcon color="primary" />,
      subtitle: districtDetail?.name || "N/A",
    },
    {
      title: "District Code",
      icon: <Code color="primary" />,
      subtitle: districtDetail?.code || "N/A",
    },
    {
      title: "Region",
      icon: <PublicOutlined color="primary" />,
      subtitle: districtDetail?.region?.name || "N/A",
    },
    {
      title: "Coordinates",
      icon: <PinDropOutlined color="primary" />,
      subtitle:
        districtDetail?.coordinates &&
        districtDetail?.coordinates?.lat != null &&
        districtDetail?.coordinates?.long != null
          ? `${districtDetail?.coordinates?.lat}, ${districtDetail?.coordinates?.long}`
          : "N/A",
    },
    {
      title: "Added By",
      icon: <PersonOutline color="primary" />,
      subtitle: districtDetail?.addedUser?.name || "N/A",
    },
    {
      title: "Created At",
      icon: <AccessTimeOutlined color="primary" />,
      subtitle: localizeDateTimeMed(districtDetail?.createdAt),
    },
    {
      title: "Updated At",
      icon: <UpdateOutlined color="primary" />,
      subtitle: localizeDateTimeMed(districtDetail?.updatedAt),
    },
    {
      title: "Status",
      icon: <InfoOutlined color="primary" />,
      subtitle: (
        <div
          className={`uppercase ${
            districtDetail?.status === "Active"
              ? "text-green-600"
              : "text-red-600"
          }`}
        >
          {districtDetail?.status}
        </div>
      ),
    },
  ];

  return !loadingDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              {districtInfo.map((info, idx) => (
                <Grid key={idx} item md={4}>
                  <InformationTile
                    title={info.title}
                    icon={() => info.icon}
                    subtitle={info.subtitle}
                  />
                </Grid>
              ))}
              {districtDetail?.description && (
                <Grid item md={12}>
                  <InformationTile
                    icon={() => <Description color="primary" />}
                    title="Description"
                    subtitle={ReactHtmlParser(districtDetail?.description)}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default DistrictBasicDetails;
